export const queryKeys = {
  sangjoReviews: ["sangjoReview"],
  parlorsAutocomplete: (keyword: string) =>
    ["parlorsAutocomplete", keyword] as const,
};
